import { makeStyles } from '@material-ui/core';
import cn from 'classnames';
import React, { ReactElement } from 'react';
import { CoreEmotionalAtmosphere } from 'wavepaths-shared/core';

import { CEAButton } from '@/component-library';

import { getCEAColour } from '../../../common/util/ceaColours';

export const SupportedCEAs = [
    CoreEmotionalAtmosphere.STILLNESS,
    CoreEmotionalAtmosphere.VITALITY,
    CoreEmotionalAtmosphere.BITTERSWEET,
    CoreEmotionalAtmosphere.TENSION,
];
export interface ICeaSelectorProps {
    targetCea?: CoreEmotionalAtmosphere;
    transitionTimeSecs?: number;
    onChange: (cea: CoreEmotionalAtmosphere) => void;
    disabled?: boolean;
}

const useStyles = makeStyles({
    container: {
        display: 'flex',
        rowGap: 'min(15px, 1vh)',
        columnGap: 'min(15px, 1vw)',
        flexDirection: 'column',
        placeContent: 'center',
        flexWrap: 'wrap',
    },
});

function CeaSelector({
    targetCea,
    transitionTimeSecs = 45,
    onChange,
    disabled = false,
}: ICeaSelectorProps): ReactElement {
    const classes = useStyles();
    return (
        <div className={cn(classes.container)}>
            {SupportedCEAs.map((cea) => (
                <CEAButton
                    key={cea}
                    aria-label={`${cea}-button`}
                    colour={getCEAColour(cea)}
                    label={cea}
                    transitionTimeSecs={transitionTimeSecs}
                    isActive={cea === targetCea}
                    onClick={() => !disabled && onChange(cea)}
                />
            ))}
        </div>
    );
}

export default CeaSelector;
